import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Core2Config } from '../../utils/core2-config';
import { ApiVisa } from '../../models/base/apivisa.model';
import { Pagination } from '../../models/pagination/pagination.model';
import { BaseService } from '../../templates/services/base-service.template';
import { getHttpHeader } from '../../utils/http-header.factory';

@Injectable({
  providedIn: 'root'
})
export class MerchantAuditService implements BaseService {

  public apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/entity/trail/merchants';

  constructor(protected readonly http: HttpClient) {}

  public getByCriteria(p: Pagination, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<any>{
    return this.http.get(`${ api_domain_url }${ this.apiUrl }/query?${ p.toString() }`, getHttpHeader(jwt_secret, tenantCode));
  }
}
